<template>
  <div class="enkronos-credits-usage" v-if="correct.length">
    <h4>
      {{ 'billings:credits_usage.title' | trans }}
      <abbr class="btn" v-help="[
        '<b>' + $t('billings:credits_usage.title') + '</b><br/>',
        'billings:credits_usage.help',
        'billings:credits_usage.usage',
      ]"></abbr>
    </h4>
    <div class="grid">
      <div>
        <h4>{{ 'billings:credits_usage.all' | trans }}</h4>
        <ins v-if="Number(current.credits) === 0">&infin;</ins>
        <ins v-else>{{ current.credits | number(3) }}</ins>
      </div>

      <div>
        <h4>{{ 'billings:credits_usage.used' | trans }}</h4>
        <ins  :class="spent ? 'state-error' : 'state-success'">
          {{ correct.log_apptokens_resource_credits_used | number(3) }}
        </ins>
      </div>
    </div>
    <!--<table>
      <tr>
        <th>{{ 'billings:credits_usage.all' | trans }}</th>
        <th>{{ 'billings:credits_usage.used' | trans }}</th>
      </tr>
      <tr>
        <td v-if="Number(current.credits) === 0">
          &infin;
        </td>
        <td v-else>
          {{ current.credits | number(3) }}
        </td>
        <td :class="spent ? 'state-error' : 'state-success'">
          {{ correct.log_apptokens_resource_credits_used | number(3) }}
        </td>
      </tr>
    </table>-->
    <template v-if="spent">
      <br/>
      <p class="spent">{{ 'billings:credits_usage.spent' | trans }}</p>
      <br/>
      <router-link :to="{name:'billings.new'}" class="btn lg">
        {{ 'billings:plans.switch' | trans }}
      </router-link>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'CreditsUsage',
    props: {
      billing: {},
    },
    computed: {
      correct () {
        if (!this.billing || !this.billing.length) {
          return [];
        }
        return this.billing.filter(b => {
          if (!b.billings_contracts || (Array.isArray(b.billings_contracts) && !b.billings_contracts.length)) {
            return false;
          }
          if (!this.current || !this.current.length) {
            return false;
          }
          return Number(this.current.id) === Number(b.billings_contracts.billings_plans_id);
        });
      },
      spent () {
        return Number(this.correct.log_apptokens_resource_credits_used) >= Number(this.current.credits) && Number(this.current.credits) !== 0;
      },
    },
    asyncComputed: {
      current () {
        return this.async('billing_plan').then(contract => contract.billings_plans);
      },
    },
  }
</script>

<style lang="scss">
  .enkronos-credits-usage {
    text-align: center;
    h4 {
      color: $accent-color;
      @include font-size(20px);
      font-weight: 700;
    }
    .grid {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      border: solid $body-bg 2px;
      > div {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        > * {
          border: solid $body-bg 2px;
          background: $default-bg;
          margin: -2px;
        }
      }
      h4 {
        min-height: calc(14px + 1.6em);
        @media (min-width: $sm-min) {
          white-space: nowrap;
        }
      }
      h4, ins {
        padding: 7px 38px;
        text-align: center;
        @media (max-width: $sm-max) {
          padding-left: 12px;
          padding-right: 12px;
        }
      }
      ins {
        font-size: 40px;
        font-weight: 700;
        text-decoration: none;
      }
    }
    /*table {
      display: inline-table;
      border-collapse: collapse;
      margin-top: 20px;
      td, th {
        border: solid $body-bg 2px;
        width: 50%;
      }
      th, td {
        padding: 7px 38px;
        @media (max-width: $sm-max) {
          padding-left: 12px;
          padding-right: 12px;
        }
      }
      td {
        font-size: 40px;
        font-weight: 700;
      }
    }*/
    .spent {
      @include font-size(18px);
      color: $state-error;
      display: inline-block;
      max-width: 375px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/sections/billings/components/CreditsUsage.vue